import {combine} from 'effector';

import {fetchChecksGrid, loadGridCsv} from 'api';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {ChecksGridRawRow} from 'types';
import {SimplePaginationContent} from 'types/api';

const domain = rootDomain.createDomain('checksDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchChecksGrid',
    handler: fetchChecksGrid,
});

export const fetchCsv = domain.createEffect({
    name: 'fetchDocumentsCsv',
    handler: loadGridCsv,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({domain});

export const data$ = domain.createStore<SimplePaginationContent<ChecksGridRawRow> | null>(null);

export const tableState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    isLoading: fetchDataFx.pending,
    exportPending: fetchCsv.pending,
});
